var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 10.36a.548.548 0 01-.23.476.952.952 0 01-.566.164h-7.74a.935.935 0 01-.566-.168A.55.55 0 013 10.36c0-.16.05-.323.15-.488L7.018 3.44C7.2 3.147 7.419 3 7.67 3c.251 0 .464.147.637.44l3.874 6.44c.101.17.151.33.151.48zM8.25 6.272V5.104H7.084v1.168c0 .075.005.145.017.212.01.067.026.141.046.224.02.083.035.153.046.212l.218 1.296h.495l.226-1.296c.011-.053.028-.123.05-.208.023-.085.04-.161.05-.228a1.28 1.28 0 00.017-.212zm0 3.096a.515.515 0 00-.171-.392.587.587 0 00-.416-.16.577.577 0 00-.406.16.515.515 0 00-.172.392c0 .155.057.287.172.396a.57.57 0 00.406.164.58.58 0 00.416-.164.527.527 0 00.171-.396z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.ccb494b9341be0ef1431f14438b9fb70.svg";
export { ForwardRef as ReactComponent };